export default __webpack_public_path__ + "static/media/twitter.4ccd4d97.jpeg";